//import { Outlet } from "react-router-dom";
import { useState } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./TopBar";
import FrameComponent from "./ProfileComponent";
import { Outlet, useLocation } from "react-router-dom";
export default function MainLayout() {

  const location = useLocation();

  const isPlayerPage = location.pathname === "/player";
  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());

  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <FrameComponent />
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Topbar */}
        <div className="sticky top-0 z-50 bg-white shrink-0">

          <Topbar
            setOpen={setOpen}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
          />

        </div>
        <div className="flex flex-1 bg-gray-100 overflow-hidden">

          {/* Sidebar */}
          <Sidebar open={open} setOpen={setOpen} />

          {/* Main Section */}
          <div className="flex-1 flex flex-col overflow-hidden">



            {/* Page Content */}
            {/* <main className="flex-1 hide-scrollbar overflow-y-auto bg-secondary p-4 md:p-6 "> */}
            {/* <Outlet /> */}
            {/* <Outlet context={{ selectedDate }} /> */}
            {/* </main> */}

            <main
              className={
                isPlayerPage
                  ? "flex-1 w-full overflow-hidden bg-black"
                  : "flex-1 w-full min-w-0 hide-scrollbar overflow-y-auto bg-secondary px-0 py-0 md:p-6"
              }
            >
              <Outlet context={{ selectedDate }} />
            </main>

          </div>
        </div>
      </div>
    </div>

  );
}
